export default(() => {

    const predefinedContributionAmounts = [1, 10, 20, 50, 100];
    const global = {
        elements: {},
        inputs: {},
        components: {},
        pageData: {},
        requestData: {}
    };

    function initialise(config){
        _cacheDom();
        _cachePageData(config);
        _cacheRequestData();
        _bindEvents();
        _initialiseComponents(config.contributionAmount);
    }

    function _cacheDom() {
        global.elements.deadlineMessageMobile = document.querySelector('[data-deadlineboxmobile]');
        global.elements.mobileInitialState = document.querySelector('[data-mobileinitialstate]');
        global.elements.mobileErrorStateExceeded = document.querySelector('[data-mobileerrorstate-exceeded]');
        global.elements.mobileErrorStateBelowMinimum = document.querySelector('[data-mobileerrorstate-belowminimum]');
        global.elements.mobileErrorStateEmpty = document.querySelector('[data-mobileerrorstate-empty]');
        global.elements.mobileErrorStateInvalidDate = document.querySelector('[data-mobileerrorstate-invaliddate]');
        global.elements.mobileProjections = document.querySelector('[data-mobileprojections]');
        global.elements.headlineContributionProjectionMobile = document.querySelector('[data-headlinecontributionprojectionmobile]');
        global.elements.contributionAmountMobile = document.querySelector('[data-contributionamountmobile]');
        global.elements.headlineContributionProjectionAmountMobile = document.querySelector('[data-contributionprojectionamountmobile]');
        global.inputs.amount = document.querySelector('[data-contributionamount]');
        global.inputs.recurringpaymentstartdate = document.querySelector('[data-recurringpaymentstartdate');
        global.components.progressBar = document.querySelector('[data-progress-bar]');
        global.components.projectionsDatalistDesktop = document.querySelector('[data-projectionsdatalistdesktop]');
        global.components.projectionsDatalistMobile = document.querySelector('[data-projectionsdatalistmobile]');
        global.components.investmentDiamond = document.querySelector('[data-investmentdiamond]');
        global.components.contributionFormGroup = document.querySelector('[data-contributionformgroup]');
        global.components.contributionLimitBox = document.querySelector('[data-contributionlimitbox]');
        global.components.contributionProjectionBox = document.querySelector('[data-contributionprojectionbox]');
        global.components.contributionFancyRadioList = document.querySelector('[data-contribution-fancy-radio-list]');
    }
    
    function _cachePageData(config){
        global.pageData.remainingAllowance = parseFloat(config.remainingAllowance);
        global.pageData.maxAllowance = parseFloat(config.maxAllowance);
        global.pageData.noFurtherStepsRequired = config.noFurtherStepsRequired;
        global.pageData.minimumContributionAmount = parseFloat(config.minimumContributionAmount);
        global.pageData.isRecurringPayment = config.isRecurringPayment;
        global.pageData.minimumErrorTemplate = global.components.contributionFormGroup.getAttribute('data-minimum-error');
        global.pageData.allowanceErrorTemplate = global.components.contributionFormGroup.getAttribute('data-allowance-error');
        global.pageData.hasEnrolled = config.hasEnrolled;
        global.pageData.contributionAmounts = config.contributionAmounts;

        global.pageData.startDateErrorState = false;
        global.pageData.amountErrorState = false;
    }

    function _cacheRequestData(){
        global.requestData.customerId = document.querySelector('[data-customerid]').value;
        global.requestData.portfolioId = document.querySelector('[data-portfolioid]').value;
        global.requestData.postUrl = document.querySelector('[data-posturl]').value;
    }

    function _bindEvents(){
        global.inputs.amount.addEventListener('valuechange', _amountChangeEventHandler);

        if(global.pageData.isRecurringPayment){
            const datebox =  global.inputs.recurringpaymentstartdate;
            
            datebox.addEventListener(datebox.events.ValueChange.name, _startDateChangeEventHandler);
        }
    }

    function _startDateChangeEventHandler(){
        const lastDirectDebitDate = 28;
        const date = global.inputs.recurringpaymentstartdate.value.slice(-2);

        global.inputs.recurringpaymentstartdate.validoverride = date > lastDirectDebitDate ? false : null;
        global.pageData.isValidStartDate = global.inputs.recurringpaymentstartdate.value >= global.inputs.recurringpaymentstartdate.min && 
            global.inputs.recurringpaymentstartdate.value <= global.inputs.recurringpaymentstartdate.max;

        global.pageData.startDateErrorState = !global.pageData.isValidStartDate;
        
        _hideErrors();
        _toggleUIAgainstStartDate();

        if(global.pageData.amountErrorState){
            _hideErrors();
            _toggleUIAgainstAmount();
        }
        
    }

    function _amountChangeEventHandler(){
        const proposedContribution = parseFloat(global.inputs.amount.value);
            
        global.pageData.isInputEmptyOrZero = isNaN(proposedContribution) || proposedContribution === 0;
            
        if(!global.pageData.isInputEmptyOrZero){
            global.pageData.isInvalidAmount = proposedContribution > global.pageData.remainingAllowance || proposedContribution < global.pageData.minimumContributionAmount;
            global.pageData.exceedsMaximumContribution = proposedContribution > global.pageData.remainingAllowance;
            global.pageData.belowMinimumContribution = proposedContribution < global.pageData.minimumContributionAmount;
        }else{
            // invalid amount should be renamed to exceedsMaximum as that is what it actually signifies
            global.pageData.isInvalidAmount = false;
            global.pageData.exceedsMaximumContribution = false;
            global.pageData.belowMinimumContribution = false;
        }
            
        const isValidAmount = !global.pageData.isInvalidAmount && 
            !global.pageData.isInputEmptyOrZero;
            
        global.pageData.amountErrorState = !isValidAmount;

        _hideErrors();
        _setLoadingState(isValidAmount);
        _updateErrorMessage();
        _toggleUIAgainstAmount();
            
        wealthify.request.debounce(_updateContribution)(proposedContribution);

        if(global.pageData.startDateErrorState){
            _hideErrors();
            _toggleUIAgainstStartDate();
        }

    }

    function _initialiseComponents(contributionAmount){
        global.inputs.amount.value = contributionAmount;  

        const contributionsToUse = (global.pageData.contributionAmounts.length ? global.pageData.contributionAmounts : predefinedContributionAmounts);

        global.components.contributionFancyRadioList.items = contributionsToUse.map((amount) => ({
            label: `£${amount}`,
            value: amount,
            onclickprop: () => {
                global.inputs.amount.value = amount;
            }
        }));

        global.components.projectionsDatalistDesktop.items = global.components.projectionsDatalistMobile.items = [{
            'label': 'If markets perform better',
            'value': '-',
            'separator': true
        }, {    
            'label': 'If markets perform worse',
            'value': '-',
            'separator': true
        }];

        if (global.pageData.noFurtherStepsRequired) {

            global.components.progressBar.classList.add('u-display__none');

        } else if (global.pageData.isRecurringPayment && global.pageData.hasEnrolled){

            global.components.progressBar.steps = [{
                'label': '1',
                'titleprop': 'Your Options',
                'state': 'selected'
            },
            {
                'label': '2',
                'titleprop': 'Confirmation',
                'disabledprop': 'true'
            }];

        } else {

            global.components.progressBar.steps = [{
                'label': '1',
                'titleprop': 'Your Options',
                'state': 'selected'
            },
            {
                'label': '2',
                'titleprop': 'Your Details',
                'disabledprop': 'true'
            },
            {
                'label': '3',
                'titleprop': 'Bank Details',
                'disabledprop': 'true'
            },
            {
                'label': '4',
                'titleprop': 'Confirmation',
                'disabledprop': 'true'
            }];

        }
    }

    function _updateContribution(proposedContribution){
        
        if(!global.pageData.isInvalidAmount && !global.pageData.isInputEmptyOrZero){

            _getPerformance(proposedContribution)
                .then(_updateProjections);
        }else{
            global.components.projectionsDatalistDesktop.items = global.components.projectionsDatalistMobile.items = [{
                'label': 'If markets perform better',
                'value': '-',
                'separator': true
            }, {    
                'label': 'If markets perform worse',
                'value': '-',
                'separator': true
            }];

            global.elements.headlineContributionProjectionAmountMobile.innerHTML = '';
            global.elements.contributionAmountMobile.innerHTML = '';
        }

        global.elements.mobileProjections.classList.remove('u-display__none');
    }
        
    function _updateErrorMessage(){
        const isInputLessThanMinimum = global.pageData.isInputEmptyOrZero || parseFloat(global.inputs.amount.value) < global.pageData.minimumContributionAmount;

        const message = isInputLessThanMinimum
            ? global.pageData.minimumErrorTemplate.replace('{{Minimum}}', global.pageData.minimumContributionAmount)
            : global.pageData.allowanceErrorTemplate.replace('{{MaxAllowance}}', wealthify.type.number.toCurrency(global.pageData.maxAllowance, false)).replace('{{RemainingAllowance}}', wealthify.type.number.toCurrency(global.pageData.remainingAllowance, true));

            
        if (isInputLessThanMinimum) {
            global.components.contributionFormGroup.error = message;
            global.elements.mobileErrorStateEmpty.textContent = global.pageData.minimumErrorTemplate;
        } else {
            global.components.contributionFormGroup.error = global.pageData.allowanceErrorTemplate;
        }
    }

    function _toggleUIAgainstStartDate(){
        const mobileErrorStateInvalidDateClassAction = global.inputs.recurringpaymentstartdate.valid ? 'add' : 'remove';
        const showContributionProjectionsMobileClassAction = global.inputs.recurringpaymentstartdate.valid ? 'remove' : 'add';

        global.elements.mobileErrorStateInvalidDate.classList[mobileErrorStateInvalidDateClassAction]('u-display__none');
        global.elements.headlineContributionProjectionMobile.classList[showContributionProjectionsMobileClassAction]('u-display__none');
        global.elements.deadlineMessageMobile.classList.add('u-display__none');
    }

    function _toggleUIAgainstAmount(){
        const projectionBoxClassAction = global.pageData.isInputEmptyOrZero ? 'add' : 'remove';
        const contributionLimitBoxClassAction = global.pageData.isInputEmptyOrZero ? 'remove' : 'add';
        const mobileErrorStateEmptyClassAction = global.pageData.isInputEmptyOrZero ? 'remove' : 'add';
        const mobileErrorStateExceedClassAction = global.pageData.exceedsMaximumContribution ? 'remove' : 'add';
        const mobileErrorStateBelowMinimumClassAction = global.pageData.belowMinimumContribution ? 'remove' : 'add'; 
        const showContributionProjectionsMobileClassAction = global.pageData.isInputEmptyOrZero || global.pageData.isInvalidAmount ? 'add' : 'remove';

        global.components.contributionProjectionBox.classList[projectionBoxClassAction]('u-display__none');
        global.components.contributionLimitBox.classList[contributionLimitBoxClassAction]('u-display__none');
        global.elements.mobileErrorStateEmpty.classList[mobileErrorStateEmptyClassAction]('u-display__none');
        global.elements.mobileErrorStateExceeded.classList[mobileErrorStateExceedClassAction]('u-display__none');
        global.elements.mobileErrorStateBelowMinimum.classList[mobileErrorStateBelowMinimumClassAction]('u-display__none');
        global.components.investmentDiamond.initialinvestmentvalue = global.inputs.amount.value;
        global.elements.headlineContributionProjectionMobile.classList[showContributionProjectionsMobileClassAction]('u-display__none');
        global.elements.deadlineMessageMobile.classList.add('u-display__none');
    }

    function _hideErrors(){

        const errorComponents = [
            global.elements.mobileErrorStateExceeded,
            global.elements.mobileErrorStateBelowMinimum,
            global.elements.mobileInitialState, 
            global.elements.mobileErrorStateEmpty,
            global.elements.mobileErrorStateInvalidDate];
            
        errorComponents.forEach((errorComponent) => {
            errorComponent.classList.add('u-display__none');
        });
    }

    function _setLoadingState(isLoading){
        global.components.investmentDiamond.loading = isLoading;
    }

    function _getPerformance(proposedContribution) {
        const config = {
            data: {
                portfolioID: global.requestData.portfolioId,
                contributorID: global.requestData.customerId,
                contributionValue: proposedContribution,
                isRecurringPayment: global.pageData.isRecurringPayment
            },
            contentType: 'application/json',
            url: global.requestData.postUrl
        };

        return wealthify.request.send(config);
    }

    function _updateProjections(projectionResponse){
        if(global.pageData.isRecurringPayment){
            global.components.investmentDiamond.totalinvestmentvalue = projectionResponse.Invest;
            global.elements.contributionAmountMobile.innerHTML = wealthify.type.number.toCurrency(projectionResponse.Invest, true);
        }else{
            global.elements.contributionAmountMobile.innerHTML = wealthify.type.number.toCurrency(projectionResponse.InitialInvestment, true);
        }

        global.components.investmentDiamond.projectedvalue = projectionResponse.PredictedValue;
        global.elements.headlineContributionProjectionAmountMobile.innerHTML = wealthify.type.number.toCurrency(projectionResponse.PredictedValue, true);

        global.components.projectionsDatalistDesktop.items = global.components.projectionsDatalistMobile.items = [{
            'label': 'If markets perform better',
            'value':  wealthify.type.number.toCurrency(projectionResponse.PredictedValueUpper),
            'separator': true
        }, {    
            'label': 'If markets perform worse',
            'value': wealthify.type.number.toCurrency(projectionResponse.PredictedValueLower),
            'separator': true
        }];

        _setLoadingState(false);
    }

    return {initialise};
})();